export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    service: '',
    imgs: []
  },
  mutations: {
    setImagesData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/more-images/index.js